// export const tenants = [
//   {
//     id: "142771b0-fa00-4241-a165-e1741dbb3c74",
//     slug: "axcess-pharmacy",
//     displayName: "Axcess Pharmacy",
//     // host: "phamacoretraining.co.ke:5014",
//     clientHost: "phamacoretraining.co.ke:5014",
//     adminHost: "phamacoretraining.co.ke:5013",
//     thirdPartyBaseUrl: "https://phamacoretraining.co.ke:5014",
//     companyProfileId: "33aca7ee-4a8c-490e-8acd-e58c474bec30",
//   },
//   {
//     id: "142771b0-fa00-4241-a165-e1741dbb3c74",
//     slug: "phamacore-dev",
//     displayName: "phAMACart Pharmacy",
//     // host: "phamacoretraining.co.ke:5013",
//     clientHost: "phamacoredev.co.ke:94",
//     adminHost: "phamacoredev.co.ke:83",
//     thirdPartyBaseUrl: "https://phamacoredev.co.ke:81",
//     companyProfileId: "74f266e5-a5b9-4cfb-ab7e-828262cb7c92",
//   },
//   {
//     id: "142771b0-fa00-4241-a165-e1741dbb3c74",
//     slug: "axcess-pharmacy",
//     displayName: "Axcess Pharmacy",
//     // host: "phamacoredev.co.ke:94",
//     clientHost: "phamacoredev.co.ke:94",
//     adminHost: null,
//     thirdPartyBaseUrl: "https://phamacoredev.co.ke:81",
//     companyProfileId: "33aca7ee-4a8c-490e-8acd-e58c474bec30",
//   },
//   {
//     id: "142771b0-fa00-4241-a165-e1741dbb3c74",
//     slug: "phamacore-dev",
//     displayName: "phAMACart Pharmacy",
//     // host: "localhost:3001",
//     clientHost: "localhost:3001",
//     adminHost: null,
//     thirdPartyBaseUrl: "https://phamacoredev.co.ke:81",
//     companyProfileId: "74f266e5-a5b9-4cfb-ab7e-828262cb7c92",
//   },
//   {
//     id: "142771b0-fa00-4241-a165-e1741dbb3c74",
//     slug: "phamacore-dev",
//     displayName: "phAMACart Pharmacy",
//     // host: "localhost:3000",
//     clientHost: "localhost:3000",
//     adminHost: null,
//     thirdPartyBaseUrl: "https://phamacoredev.co.ke:81",
//     companyProfileId: "74f266e5-a5b9-4cfb-ab7e-828262cb7c92",
//   },
//   {
//     id: "c78f4bef-43af-49a5-aa98-cd4f12bc3962",
//     slug: "axcess-pharmacy",
//     displayName: "Axcess Pharmacy",
//     // host: null,
//     clientHost: null,
//     adminHost: null,
//     thirdPartyBaseUrl: "https://phamacoreonline.co.ke:5022",
//     companyProfileId: "c528821d-d583-4575-a841-81955d0b98fa",
//   },
//   {
//     id: "5DD800EC-0C56-4E96-B204-EAF91239B0A2",
//     slug: "makadara-chemists",
//     displayName: "Makadara Chemists",
//     // host: "makadarachem.co.ke:5008",
//     clientHost: "makadarachem.co.ke",
//     adminHost: "makadarachem.co.ke:5006",
//     thirdPartyBaseUrl: "https://corebasebackendmakadara.co.ke:5020",
//     companyProfileId: "27e6e6ef-4030-4e4d-ba82-cc95ebb04443",
//   },
//   {
//     id: "142771b0-fa00-4241-a165-e1741dbb3c74",
//     slug: "phamacore-prod",
//     displayName: "phAMACart Pharmacy",
//     // host: "phamacoredispatch.co.ke:5006",
//     clientHost: "phamacoredispatch.co.ke:5008",
//     adminHost: "phamacoredispatch.co.ke:5006",
//     thirdPartyBaseUrl: "https://phamacoreonline.co.ke:5022",
//     companyProfileId: "74f266e5-a5b9-4cfb-ab7e-828262cb7c92",
//   },
// ];
// export const tenants = JSON.parse(localStorage.getItem("tenants")) ?? [];

let currentTenantId = "";

export const setTenantId = (tenantId) => {
  currentTenantId = tenantId;
};

export const getTenantId = () => {
  return currentTenantId;
};
